import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IncomeReceipt  {
    _originalTypeClassName = "zERP.BO.IncomeReceipt";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IncomeReceipt.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Details = [];
this.Budget = new Domain.Budget();
this.Documents = [];
this.FileUploads = [];
this.Id = null;
this.DateCreated = null;
this.Number = null;
this.TotalAmount = null;
this.IsPaid = false;
this.DatePayed = null;
this.Status = null;
this.Notes = null;
this.DateIssued = null;
this.SeriesCode = null;
this.ExternalSourceId = null;
this.ProtocolNumber = null;
this.MappedWithAccounting = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateCreated:any;
Number:any;
TotalAmount:any;
IsPaid:any;
DatePayed:any;
Status:any;
Notes:any;
DateIssued:any;
SeriesCode:any;
ExternalSourceId:any;
ProtocolNumber:any;
MappedWithAccounting:any;
OwnerPaymentOrder:any;
TransactionEntity:any;
Entity:any;
Details:any;
Budget:any;
FiscalYear:any;
CreatedBy:any;
Documents:any;
Payment:any;
Series:any;
Cancellation:any;
FileUploads:any;
static setOwnerPaymentOrder = ($this, value) => {
var oldValue = $this.OwnerPaymentOrder;
$this.OwnerPaymentOrder = value;
if (value != null) {
if (oldValue != null) {
Domain.PaymentOrder.removeIncomeReceipts(oldValue, $this);
}
Domain.PaymentOrder.addIncomeReceipts(value, $this);
}
}
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.IncomeReceipt.removeDetails($this, $this.Details[0]);
                }

                Domain.IncomeReceipt.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.IncomeReceipt.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.IncomeReceipt.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
}
static clearDetails = ($this) => { $this.Details = null; }
static setBudget = ($this, value) => {
var oldValue = $this.Budget;
$this.Budget = value;
if (value != null) {
}
}
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
if (oldValue != null) {
Domain.UserAccount.removeIncomeReceipt(oldValue, $this);
}
Domain.UserAccount.addIncomeReceipt(value, $this);
}
}
static setDocuments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Documents == null) $this.Documents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Documents.length > 0) {
                    Domain.IncomeReceipt.removeDocuments($this, $this.Documents[0]);
                }

                Domain.IncomeReceipt.addManyDocuments($this, copyItems);
            }
static addManyDocuments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.IncomeReceipt.addDocuments($this, items[i]);
                }
            }
static addDocuments = ($this, item) => {
                if ($this.Documents == null) $this.Documents = [];
                if (item == null || $this.Documents.indexOf(item) > -1) return;
                $this.Documents.push(item);
if (item.IncomeReceipt != $this) {
Domain.AadeBookInvoiceType.setIncomeReceipt(item, $this);
}
}
static addRangeDocuments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.IncomeReceipt.addDocuments($this, item));
            }
static removeDocuments = ($this, item) => {
                if ($this == null || $this.Documents == null || $this.Documents.indexOf(item) === -1) return;
                var _index = $this.Documents.indexOf(item);
                $this.Documents.splice(_index, 1);
item.IncomeReceipt = null;
}
static clearDocuments = ($this) => { $this.Documents = null; }
static setPayment = ($this, value) => {
var oldValue = $this.Payment;
$this.Payment = value;
if (value != null) {
if (oldValue != null && oldValue.IncomeReceipt != null) { oldValue.IncomeReceipt = null; }
if ($this.Payment.IncomeReceipt !== $this) {
Domain.Payment.setIncomeReceipt(value, $this);
}
}
}
static setSeries = ($this, value) => {
var oldValue = $this.Series;
$this.Series = value;
if (value != null) {
}
}
static setCancellation = ($this, value) => {
var oldValue = $this.Cancellation;
$this.Cancellation = value;
if (value != null) {
}
}
static setFileUploads = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileUploads == null) $this.FileUploads = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileUploads.length > 0) {
                    Domain.IncomeReceipt.removeFileUploads($this, $this.FileUploads[0]);
                }

                Domain.IncomeReceipt.addManyFileUploads($this, copyItems);
            }
static addManyFileUploads = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.IncomeReceipt.addFileUploads($this, items[i]);
                }
            }
static addFileUploads = ($this, item) => {
                if ($this.FileUploads == null) $this.FileUploads = [];
                if (item == null || $this.FileUploads.indexOf(item) > -1) return;
                $this.FileUploads.push(item);
}
static addRangeFileUploads = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.IncomeReceipt.addFileUploads($this, item));
            }
static removeFileUploads = ($this, item) => {
                if ($this == null || $this.FileUploads == null || $this.FileUploads.indexOf(item) === -1) return;
                var _index = $this.FileUploads.indexOf(item);
                $this.FileUploads.splice(_index, 1);
}
static clearFileUploads = ($this) => { $this.FileUploads = null; }

static GetClassName(): any{return "IncomeReceipt";
}
static UpdateAmounts($this: any): any{$this.TotalAmount = $this?.Details?.linq?.sum((d) => d?.Amount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}